import { isFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-18497 CLOUDWEB-18497
 * Удаление файла из раздела "Доступные мне"
 */
export const INCOMING_PUBLIC_DELETION = isFeature('incoming-public-deletion');
